export class UniversityApplicantInfo {
  enrollid: number = null;
  status: number = null;
  canceled_time: Date = null;
  submittedTime: Date = null;
  confirmed_without_documents_person: number = null;
  confirmed_without_documents_user: any = null;
  confirmed_without_documents_time: Date = null;
  confirmed_with_documents_person: number = null;
  confirmed_with_documents_user: any = null;
  confirmed_with_documents_time: Date = null;
  sent_to_revision_person: number = null;
  sent_to_revision_user: any = null;
  sent_to_revision_time: Date = null;
  corrected_time: Date = null;
  rejected_person: number = null;
  rejected_user: any = null;
  rejected_time: Date = null;
  archived_person: number = null;
  archived_user: any = null;
  archived_time: Date = null;
  recovered_person: number = null;
  saved_person: number = null;
  submitted_person: number = null;
  recovered_user: any = null;
  saved_user: any = null;
  submitted_user: Date = null;
  studentid: number = null;
  saved_time: Date = null;
  applicationtype: number = null;
  publication_status: number = null;
  reception_status: number = null;
  rejectedReason: any = null;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/university-applicant-info.ts